// extracted by mini-css-extract-plugin
export default {"resourceIcon":"gathering-rates_resourceIcon__ZoHWQ","disabled":"gathering-rates_disabled__Gxj4D"};